import {useState} from "react"
import IconClose from "@/assets/icons/icon-close.svg?react"
import IconButton from '@/components/ui/IconButton/IconButton'
import Modal from "@/components/modals/Modal/Modal"
import AccountSettingsModalProfile from "./components/AccountSettingsModalProfile/AccountSettingsModalProfile"
import AccountSettingsModalPreferences from "./components/AccountSettingsModalPreferences/AccountSettingsModalPreferences"
import AccountSettingsModalNotifications from "./components/AccountSettingsModalNotifications/AccountSettingsModalNotifications"
import AccountSettingsNavigation from "./components/AccountSettingsNavigation/AccountSettingsNavigation"
import css from "./AccountSettingsModal.module.css"

export type AccountTabType = 'profile' | 'preferences' | 'notifications'

export const NAV_OPTIONS: { label: string; tab: AccountTabType }[] = [
    { label: 'Profile', tab: 'profile' },
    { label: 'Preferences', tab: 'preferences' },
    { label: 'Notifications', tab: 'notifications' },
]

interface AccountSettingsModalProps {
    onClose: () => void
    initialTab?: AccountTabType
}

const AccountSettingsModal = ({onClose, initialTab = 'profile'}: AccountSettingsModalProps) => {
    const [activeTab, setActiveTab] = useState<AccountTabType>(initialTab)

    const renderContent = () => {
        switch (activeTab) {
            case 'profile':
                return <AccountSettingsModalProfile/>
            case 'preferences':
                return <AccountSettingsModalPreferences/>
            case 'notifications':
                return <AccountSettingsModalNotifications/>
            default:
                return null
        }
    }

    return (
        <Modal onClose={onClose} maxWidth={728} mobileFullScreen>
            <div className={css.buttons}>
                <IconButton icon={<IconClose />} onClick={onClose} />
            </div>
            <div className={css.container}>
                <div className={css.navigation}>
                    <AccountSettingsNavigation options={NAV_OPTIONS} activeTab={activeTab} onTabChange={setActiveTab} />
                </div>
                <div className={css.content}>
                    {renderContent()}
                </div>
            </div>
        </Modal>
    )
}

export default AccountSettingsModal
